import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';
import * as React from 'react';
import { PurchaseMode, Template, Theme } from '../../enums';

export const PageModeContext = React.createContext({
  theme: Theme.AdvancedPlans,
  template: Template.Grid,
  purchaseMode: PurchaseMode.DEFAULT,
  isChangePlan: false,
});

export const usePageModeContext = () => React.useContext(PageModeContext);

interface PageModeProviderProps extends InjectedExperimentsProps {
  theme: Theme;
  template: Template;
  locale: string;
  purchaseMode: PurchaseMode;
  isChangePlan: boolean;
}

const PageModeProviderComp: React.FC<PageModeProviderProps> = ({
  children,
  theme,
  template,
  purchaseMode,
  isChangePlan,
}) => {
  return (
    <PageModeContext.Provider
      value={{ theme, template, purchaseMode, isChangePlan }}
    >
      <>{children}</>
    </PageModeContext.Provider>
  );
};

export const PageModeProvider = withExperiments(PageModeProviderComp);
